import myProfileCommitTypes from './commit-types';
import ReducerUtilities from '../../../shared/store/reducer-utilities';
import userModel from '../../models/user';

const INITIAL_MY_PROFILE_STATE = {
  isLoading: [],
  profile: null,
};

function myProfileReducers(state = INITIAL_MY_PROFILE_STATE, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case myProfileCommitTypes.REPLACE_MY_PROFILE:
      return {
        ...state,
        profile: userModel(action.profile),
      };
    case myProfileCommitTypes.RESET_MY_PROFILE_STATE:
      return { ...INITIAL_MY_PROFILE_STATE };
    case myProfileCommitTypes.SET_MY_PROFILE:
      return {
        ...state,
        profile: userModel(action.profile),
      };
    case myProfileCommitTypes.SET_MY_PROFILE_IS_LOADING:
      return {
        ...state,
        isLoading: ReducerUtilities.updateIsLoading(action.isLoading, state.isLoading),
      };
    default:
      return state;
  }
}

export default myProfileReducers;
